import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import roles from "../../const/roles";
import MyAutocomplate from "../autocomplete/autocomplete";
import { RequestContext } from "../../context/request.context";
import { FaTelegram, FaUser } from "react-icons/fa";
import { MdPassword } from "react-icons/md";
import TelegramUpdate from "./update.telegram";
import ResetPassword from "./reset.password";
import priceTypes from "../../const/priceTypes";
import {IoClose} from "react-icons/io5";
import Divider from "@mui/material/Divider";

/**
 * Do'kon va ombor nomini taqqoslash uchun soddalashtiradi.
 *
 * `shop` va `warehouse` — ikki alohida jadval, lekin ayni bir joylarni yozadi
 * (11 ta ombor nomining hammasi do'konlar ro'yxatida ham bor). Apostrof esa
 * uch xil yoziladi: "Qo'qon", "Qo`qon", "Qoʻqon".
 */
const plainName = (name) =>
  (name || "")
    .toLowerCase()
    .replace(/[`‘’ʻʼ]/g, "'")
    .replace(/\s+/g, " ")
    .trim();

const UserComponent = ({ currentUser, title, buttonText, action, close }) => {
  const [disabled, setDisabled] = useState(true);
  const [shops, setShops] = useState([]);
  const [cbClient, setCbClient] = useState([]);
  const [regions, setRegions] = useState([]);
  const [serverUsers, setServerUsers] = useState([]);
  // 1C tashkilotlari (clientsource) va biznes-regionlari (bregion) --
  // agent ilovada qaysi 1C mijozlarini ko'rishini belgilaydi.
  const [sources, setSources] = useState([]);
  const [clientRegions, setClientRegions] = useState([]);
  useEffect(() => {
    request("/client/organizations", "GET").then((d) => setSources(Array.isArray(d) ? d : []));
    request("/client/regions", "GET").then((d) => setClientRegions(Array.isArray(d) ? d : []));
    // Yashiringanlari ham kerak: asosiy do'kon yashiringan omborga to'g'ri
    // kelishi mumkin ("Qo'qon diller asosiy ombor") va uni ataylab
    // biriktirganda ko'rinishi kerak.
    request("/warehouse", "GET").then((d) => setWarehouses(Array.isArray(d) ? d : []));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [selectedSources, setSelectedSources] = useState(currentUser?.clientSources || []);
  const [selectedClientRegions, setSelectedClientRegions] = useState(currentUser?.clientRegions || []);
  // Ko'rinadigan omborlar. Ilgari bu faqat jadvaldagi alohida tugmada edi va
  // shu sababdan hech kimda belgilanmay qolgan: bo'sh ro'yxat "hammasi"
  // degani, ya'ni har bir agent butun qoldiqni ko'rardi. Endi shu oynada.
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouses, setSelectedWarehouses] = useState(currentUser?.warehouses || []);
  const { request, data } = useContext(RequestContext);
  useEffect(() => {
    if (data["/shop/all?size=1000000"])
      return setShops(data["/shop/all?size=1000000"]);
    request("/shop/all?size=1000000", "GET").then((data) => {
      setShops(data.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (data["/cb/client/all?size=1000000"])
      return setCbClient(data["/cb/client/all?size=1000000"]);
    request("/cb/client/all?size=1000000", "GET").then((data) => {
      setCbClient(data.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (data["/server-user/all?size=1000000"])
      return setServerUsers(data["/server-user/all?size=1000000"]);
    request("/server-user/all?size=1000000", "GET").then((data) => {
      setServerUsers(data.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (data["/region/all"])
      return setServerUsers(data["/server-user/all?size=1000000"]);
    request("/region/all", "GET").then((data) => {
      setRegions(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selectedShop, setSelectedShop] = useState(currentUser?.shop || null);
  const [selectableShop, setSelectableShop] = useState(null);
  const [selectedShopList, setSelectedShopList] = useState(currentUser?.shops || []);
  const [selectedClient, setSelectedClient] = useState(
    currentUser?.cbClient || null
  );
  const [selectedServerUser, setSelectedServerUser] = useState(
    currentUser?.serverUser || null
  );
  const [selectedRegion, setSelectedRegion] = useState(
    currentUser?.region || null
  );

  const [updateType, setUpdateType] = useState("all");

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          m: 1,
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <Box
          sx={{
            display: "flex",
            gap: "0.5rem",
          }}
        >
          <IconButton
            color="success"
            title="Asosiy"
            size="small"
            onClick={() => {
              setUpdateType("all");
            }}
          >
            <FaUser />
          </IconButton>
          <IconButton
            color="primary"
            title="Telegram ulash"
            size="small"
            onClick={() => {
              setUpdateType("telegram");
            }}
          >
            <FaTelegram />
          </IconButton>
          <IconButton
            color="warning"
            title="Faqat parolni o'zgartirish"
            size="small"
            onClick={() => {
              setUpdateType("password");
            }}
          >
            <MdPassword />
          </IconButton>
        </Box>
      </Box>
      {updateType === "all" ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            const data = Object.fromEntries(formData);
            data.shopId = selectedShop?.id || null;
            data.serverUserId = selectedServerUser?.id || null;
            data.regionId = selectedRegion?.id || null;
            data.shopIds = (selectedShopList && selectedShopList.length > 0)?selectedShopList.map((item) => item.id):null;
            data.cbClientId = selectedClient?.id || null;
            data.clientSources = selectedSources;
            data.clientRegionIds = selectedClientRegions.map((r) => r.id);
            data.warehouseIds = selectedWarehouses.map((w) => w.id);
            action(data);
            close();
          }}
          onInput={() => {
            setDisabled(false);
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            padding: "1rem",
          }}
        >
          <TextField
            label="Username"
            name="username"
            defaultValue={currentUser?.username}
            fullWidth
            required
            size="small"
          />
          <TextField
            label="Ismi"
            name="firstName"
            defaultValue={currentUser?.firstName}
            fullWidth
            size="small"
            required
          />
          <TextField
            label="Familiyasi"
            name="lastName"
            defaultValue={currentUser?.lastName}
            fullWidth
            required
            size="small"
          />
          <FormControl fullWidth>
            <InputLabel id="select-role">Rol</InputLabel>
            <Select
              labelId="select-role"
              label="Roli"
              name="role"
              defaultValue={currentUser?.role || "USER"}
              fullWidth
              size="small"
            >
              {roles.map((role, i) => (
                <MenuItem value={role.en} key={i}>
                  {role.uz}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="priceType">Narx turi</InputLabel>
            <Select
              labelId="priceType"
              label="Narx turi"
              name="priceType"
              defaultValue={currentUser?.priceType || "WHOLESALE"}
              fullWidth
              size="small"
            >
              {priceTypes.map((role, i) => (
                <MenuItem value={role.en} key={i}>
                  {role.uz}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <MyAutocomplate
            label="Regionni tanlang"
            options={regions}
            value={selectedRegion}
            getOptionLabel={(option) => {
              return option.name;
            }}
            renderOption={(props, options) => {
              return (
                <li {...props}>
                  <Typography variant="body2">{options.name}</Typography>
                </li>
              );
            }}
            getValue={(value) => {
              setDisabled(false);
              setSelectedRegion(value);
            }}
          />
          <MyAutocomplate
            label="Asosiy do'konni tanlang"
            options={shops}
            value={selectedShop}
            getOptionLabel={(option) => {
              return option.name;
            }}
            renderOption={(props, options) => {
              return (
                <li {...props}>
                  <Typography variant="body2">{options.name}</Typography>
                </li>
              );
            }}
            getValue={(value) => {
              setDisabled(false);
              setSelectedShop(value);
              // Asosiy do'kon tanlanganda shu nomdagi ombor o'zi belgilanadi:
              // amalda ikkisi bir joy, lekin odam ikkinchisini belgilashni
              // unutib, agentga butun qoldiq ochilib qolardi. Belgilangani
              // olib tashlanmaydi — bu taklif, majburlash emas.
              const match = warehouses.find((w) => plainName(w.name) === plainName(value?.name));
              if (match && !selectedWarehouses.some((w) => w.id === match.id)) {
                setSelectedWarehouses([...selectedWarehouses, match]);
              }
            }}
          />
          <Autocomplete
            multiple
            size="small"
            options={warehouses}
            value={selectedWarehouses}
            getOptionLabel={(o) => o.displayName || o.name}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            renderOption={(props, o) => (
              <li {...props} key={o.id}>
                <span>
                  {o.displayName || o.name}
                  {o.hidden ? (
                    <Typography component="span" variant="caption" sx={{ color: "text.secondary", ml: 1 }}>
                      (umumiy ro'yxatda yashirilgan)
                    </Typography>
                  ) : null}
                </span>
              </li>
            )}
            onChange={(e, v) => {
              setDisabled(false);
              setSelectedWarehouses(v);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  label={option.displayName || option.name}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Omborlar (qoldiq shu omborlar bo'yicha ko'rinadi)"
                helperText="Bo'sh — yashirilmagan hamma ombor ko'rinadi. Mijozga hisob ochilganda agent faqat shu ro'yxatdan bera oladi."
              />
            )}
          />
          <MyAutocomplate
              label="Mijozni tanlang"
              options={cbClient}
              value={selectedClient}
              getOptionLabel={(option) => {
                return option.name;
              }}
              renderOption={(props, options) => {
                return (
                    <li {...props}>
                      <Typography variant="body2">{options.name}</Typography>
                    </li>
                );
              }}
              getValue={(value) => {
                setDisabled(false);
                setSelectedClient(value);
              }}
          />
          <MyAutocomplate
              label="Do'konlarni tanlang"
              options={shops}
              value={selectableShop}
              getOptionLabel={(option) => {
                return option.name;
              }}
              renderOption={(props, options) => {
                return (
                    <li {...props}>
                      <Typography variant="body2">{options.name}</Typography>
                    </li>
                );
              }}
              getValue={(value) => {
                setSelectableShop(value);
                if (selectedShopList.find((item) => item.id === value.id)) return;
                setSelectedShopList([...selectedShopList, value]);
              }}
          />
          <div>
            <ul style={{
                listStyle: "none",
                paddingLeft: 4,
                paddingRight: 4,
                margin: 0,
                maxHeight: "150px",
                overflow: "auto"
            }}>
              {selectedShopList.map((shop) => (
                  <li style={{
                    gap: 4,
                    padding: 4,
                  }}>
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}>
                      <Typography variant="body2">{shop.name}</Typography>
                      <IconButton
                          onClick={() => {
                            setSelectedShopList(selectedShopList.filter((item) => item.id !== shop.id));
                          }} style={{
                        padding: 0,
                        margin: 0,
                      }}>
                        <IoClose color={'red'}/>
                      </IconButton>
                    </div>
                    <Divider/>
                  </li>
              ))
              }
            </ul>
          </div>
          <Autocomplete
            multiple
            size="small"
            options={sources.map((o) => o.name)}
            value={selectedSources}
            onChange={(e, v) => {
              setDisabled(false);
              setSelectedSources(v);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip size="small" label={option} {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="1C tashkilotlari (agent shu mijozlarni ko'radi)"
                helperText="Bo'sh — tashkilot bo'yicha hech kim (region yoki do'kon/ombor bo'yicha ko'radi)"
              />
            )}
          />
          <Autocomplete
            multiple
            size="small"
            options={clientRegions}
            // 1C da biznes-regionlar daraxt: "Qo'qon shahri" ning otasi
            // "Farg'ona viloyati". Viloyat tanlansa tumanlari ham doiraga
            // kiradi, shuning uchun ro'yxatda TUMANLARI BILAN son turadi --
            // aks holda "Farg'ona viloyati (32)" deb ko'rsatib, amalda 227 ta
            // mijoz chiqadi va bu chalg'itadi.
            //
            // Bu maydon boshqalaridan farq qiladi: ombor, do'kon, tashkilot
            // va 1C menejeri doirani KENGAYTIRADI, region esa CHEGARALAYDI.
            // Shunday bo'lmasa, Qo'qon omborida qarzi bor Toshkent mijozi
            // Qo'qon agentiga ko'rinib qolardi (2026-09-08).
            getOptionLabel={(o) =>
              `${o.name}${o.total ? ` (${o.total})` : o.clients ? ` (${o.clients})` : ""}`
            }
            renderOption={(props, o) => (
              <li {...props} key={o.id}>
                <span>
                  {o.name}
                  {o.parent ? (
                    <Typography component="span" variant="caption" sx={{ color: "text.secondary", ml: 0.5 }}>
                      ← {o.parent}
                    </Typography>
                  ) : null}
                  <Typography component="span" variant="caption" sx={{ color: "text.secondary", ml: 1 }}>
                    {o.total > o.clients
                      ? `${o.total} ta (o'zida ${o.clients}, tumanlari bilan)`
                      : `${o.clients} ta`}
                  </Typography>
                </span>
              </li>
            )}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            value={selectedClientRegions}
            onChange={(e, v) => {
              setDisabled(false);
              setSelectedClientRegions(v);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip size="small" label={option.name} {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="1C biznes-regionlari"
                helperText="Chegara: tanlansa, agent boshqa regiondagi mijozni ombor yoki do'kon orqali ham ko'rmaydi. Viloyat tanlansa tumanlari ham kiradi (Farg'ona viloyati → Qo'qon, Yaypan, Bag'dod...). Qavsdagi son — tumanlari bilan."
              />
            )}
          />
          <MyAutocomplate
            label="1C menejeri (Основной менеджер) — buyurtma muallifi"
            options={serverUsers}
            value={selectedServerUser}
            getOptionLabel={(option) => {
              return option.name;
            }}
            renderOption={(props, options) => {
              return (
                <li {...props}>
                  <Typography variant="body2">{options.name}</Typography>
                </li>
              );
            }}
            getValue={(value) => {
              setDisabled(false);
              setSelectedServerUser(value);
            }}
          />
          <TextField label="Parol" name="password" fullWidth size="small" />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={disabled}
          >
            {buttonText}
          </Button>
        </form>
      ) : updateType === "telegram" ? (
        <TelegramUpdate user={currentUser} close={close} />
      ) : (
        <ResetPassword user={currentUser} close={close} />
      )}
    </Box>
  );
};

export default UserComponent;
